import { FunctionComponent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { TMapOptions } from '../../types/naverMap';

const ComplexStandardPriceMap: FunctionComponent<TMapOptions> = () => {
  const location = useLocation();
  const { search } = location;
  const urlParameter = new URLSearchParams(search);
  const urlLatitude = urlParameter.get('latitude');
  const urlLongitude = urlParameter.get('longitude');
  const urlComplexName = urlParameter.get('complexName');

  let map: naver.maps.Map;
  let mapOption = {
    center: new naver.maps.LatLng(Number(urlLatitude), Number(urlLongitude)),
    zoom: 15,
    tileDuration: 300,
  };

  useEffect(() => {
    if (!map) {
      map = new naver.maps.Map('map', mapOption);
      const marker = new naver.maps.Marker({
        position: new naver.maps.LatLng(
          Number(urlLatitude),
          Number(urlLongitude),
        ),
        title: urlComplexName as string,
        map: map ?? undefined,
        zIndex: 999,
        icon: `./images/Ic_complex_marker.svg`,
      });

      const infoWindow = new naver.maps.InfoWindow({
        content: [
          '<div style="padding: 5px;background-color: #fff; border: 1px solid #9E9E9E; border-radius: 4px; width:100%; text-align: center;">',
          `<div style="font-weight: 700; font-size: 12px; color: #333;">${urlComplexName}</div>`,
          '</div>',
        ].join(''),
        backgroundColor: 'rgba(255, 255, 255, 0)',
        disableAnchor: true,
        borderWidth: 0,
        pixelOffset: new naver.maps.Point(0, 35),
      });
      infoWindow.open(map, marker);
    }
  }, []);

  return (
    <>
      <NaverMap id="map" />
    </>
  );
};

export default ComplexStandardPriceMap;

const NaverMap = styled.div`
  width: 100%;
  height: 100%;
`;
